.description__heading {
  margin-top: 20px;
  margin-bottom: 20px;
}